import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "./apiRequest";
import { isTokenExpired } from "../../Utils/Utils";
import { logOut, raiseError } from "../actions/action";

const addProduct = createAsyncThunk('add/product', async (productDetail, { dispatch }) => {
  if (!isTokenExpired()) {
    try {
      const response = await apiRequest.post(`/products`, productDetail);
      return response.data;
    } catch (error) {
      dispatch(raiseError("Something went wrong. please try after sometime"));
    }
  } else {
    dispatch(logOut());
    dispatch(raiseError("Please login again"));
  }
});

const editProduct = createAsyncThunk('edit/product', async ({ id, formData }, { dispatch }) => {
  try {
    const response = await apiRequest.put(`/products/${id}`, formData);
    return response.data;
  } catch (error) {
    dispatch(raiseError("Failed to update product."));
  }
});

const deleteProduct = createAsyncThunk('delete/product', async (id, { dispatch }) => {
  try {
    await apiRequest.delete(`/products/${id}`);
    return id;
  } catch (error) {
    dispatch(raiseError("Failed to delete product."));
  }
});

export { addProduct, editProduct, deleteProduct };